export default function Contact() {
  return (
    <section id="contact" className="bg-[#1a202c] py-20">
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex items-center justify-between pb-16 border-b border-[#2d3748]">
          <div className="flex items-center gap-4">
            <img 
              src="https://public.readdy.ai/ai/img_res/d4bce4b0-6b71-4201-b51c-c004861c34e8.png" 
              alt="ROLI SH.P.K. Logo" 
              className="h-10 w-10 object-contain"
            />
            <span className="text-xl font-medium text-white tracking-wide">ROLI SH.P.K.</span>
          </div>
          <p className="text-sm text-[#a0aec0]">Innovating mobile experiences since establishment</p>
        </div>

        <div className="grid grid-cols-4 gap-20 py-16">
          <div>
            <h3 className="text-xs font-bold text-[#718096] tracking-widest mb-4">ADDRESS</h3>
            <div className="space-y-3">
              <p className="text-base text-[#e2e8f0]">Mamurras, Rruga Zhej</p>
              <p className="text-base text-[#e2e8f0]">Zona Kadastrale nr.1768</p>
              <p className="text-base text-[#e2e8f0]">LEZHE, 4500</p>
              <p className="text-base text-[#e2e8f0]">Albania</p>
            </div>
          </div>

          <div>
            <h3 className="text-xs font-bold text-[#718096] tracking-widest mb-4">CONTACT</h3>
            <div className="space-y-6">
              <div>
                <p className="text-sm text-[#718096] mb-1">Email</p>
                <p className="text-base text-[#e2e8f0]">info@rolishpk.com</p>
              </div>
              <div>
                <p className="text-sm text-[#718096] mb-1">Phone</p>
                <p className="text-base text-[#e2e8f0]">+1 9104066265</p>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-xs font-bold text-[#718096] tracking-widest mb-4">COMPANY</h3>
            <div className="space-y-3">
              <p className="text-base text-[#e2e8f0]">iOS Development</p>
              <p className="text-base text-[#e2e8f0]">VPN Solutions</p>
              <p className="text-base text-[#e2e8f0]">Cleaner Apps</p>
              <p className="text-base text-[#e2e8f0]">Mobile Security</p>
            </div>
          </div>

          <div className="text-right">
            <p className="text-lg text-white mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
              © ROLI SH.P.K. 2025
            </p>
            <p className="text-sm text-[#a0aec0] mb-8">All rights reserved</p>
            <div className="flex justify-end gap-4 text-sm text-[#a0aec0]">
              <span className="hover:text-white transition-colors cursor-pointer">LinkedIn</span>
              <span>|</span>
              <span className="hover:text-white transition-colors cursor-pointer">Twitter</span>
              <span>|</span>
              <span className="hover:text-white transition-colors cursor-pointer">GitHub</span>
              <span>|</span>
              <span className="hover:text-white transition-colors cursor-pointer">Medium</span>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-between pt-20">
          <div className="w-[28%] rounded-3xl overflow-hidden shadow-2xl">
            <img
              src="https://public.readdy.ai/ai/img_res/870631f70f6d7b8112f9cfd09846851e.jpg"
              alt="Product Showcase"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div className="ml-12" style={{ fontFamily: 'Playfair Display, serif' }}>
            <p className="text-3xl text-[#e2e8f0] leading-snug">
              Building the future<br />
              of mobile<br />
              applications
            </p>
          </div>

          <div className="ml-auto mr-16 max-w-sm">
            <p className="text-sm text-[#a0aec0] leading-relaxed mb-6">
              Stay updated with our latest releases and security updates
            </p>
            <div className="flex gap-3">
              <input
                type="email"
                placeholder="Enter email"
                className="flex-1 h-14 px-5 bg-transparent border-2 border-[#2d3748] rounded-xl text-white placeholder-gray-500 focus:outline-none focus:border-[#3182ce] transition-colors"
              />
              <button className="w-14 h-14 bg-[#3182ce] hover:bg-[#2c5282] rounded-xl flex items-center justify-center text-white transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}